import { render, staticRenderFns } from "./topControllerSearchSize.vue?vue&type=template&id=00684704&"
import script from "./topControllerSearchSize.vue?vue&type=script&lang=ts&"
export * from "./topControllerSearchSize.vue?vue&type=script&lang=ts&"
import style0 from "./topControllerSearchSize.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports